/**
 * The single place the JWT is persisted. One key, one module — so clearing
 * the session is never partial.
 */
const TOKEN_KEY = 'aac_erp_token';

export function readToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    // Private mode / storage disabled — behave as if signed out.
    return null;
  }
}

export function writeToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Non-fatal: the session simply will not survive a reload.
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // Nothing to do — the token was never persisted.
  }
}

export { TOKEN_KEY };
